import React from 'react';
import logowhite from '../assetss/img/logo_blanco.png'


function Header() {

  return (
    <>
      <div className='bg-gradient-to-r from-[#3F8CCB] to-[#129FDA]'>
        <div className="flex justify-center">
          <div className="mt-8 mb-4" >
            <img src={logowhite} alt="navbar-logo" />
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
